import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { LoginModel } from 'app/core/models/login.model';
import { MembershipService } from 'app/core/services/membership.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { APPLICATION_ID } from 'app/core/models/constants';
import { SecurityService } from 'app/services/security.service';
import { TokenModel } from 'app/core/models/token.model';
import { SessionIdleService } from 'app/services/session-idle.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent extends NexusComponent implements OnInit {
    public form = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.required),
        password: new UntypedFormControl('', Validators.required)
    });
    public model: LoginModel = new LoginModel();
      public token_model: TokenModel;
    public result_model: NexusFormResultModel = new NexusFormResultModel();
      public session_idle_expiry = true;
  public session_idle_expiry_mins =15;

    constructor(public membership: MembershipService, private router: Router, private route: ActivatedRoute,private security_service: SecurityService,private session_idle_service: SessionIdleService) {
        super();
           this.session_idle_expiry =this.session_idle_service.session_expired;
      this.session_idle_expiry_mins = this.session_idle_service.idle_ttl_minutes;
    }

    submit() {
        this.result_model.Reset();
        this.StartSpinner();
        this.model.device_token= this.security_service.GetDeviceToken();
        this.model.application_id= APPLICATION_ID;
        this.membership.Login(this.model).subscribe(
            data => {
                this.StopSpinner();

              this.token_model = data;
                this.StopSpinner();
                if(data.mfa_required){
                  const otp_url = `otp/${data.otp_id}`;
                  this.router.navigate([otp_url]);
                  return;
                } else{
                  if (data.token) {
                      this.result_model.Success();
                      this.membership.SetToken(data);

                      if (!data.enrollment_complete) {
                          this.router.navigate(['/signup', data.signup_id]);
                          return;
                      }

                      if (!data.utilities_linked) {
                          this.router.navigate(['/utilities']);
                          return;
                      }

                      if (this.membership.redirectUrl) {
                          const route =this.membership.redirectUrl;
                          this.membership.redirectUrl=null;
                          this.router.navigate([route]);
                          return;
                      }

                      this.router.navigate(['/']);
                    }
                }





            },
            err => {
                this.result_model.Error(err);
                this.StopSpinner();
            });
    }

    ngOnInit() {
        this.form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.model);
        });

        this.route.paramMap.subscribe(params => {
            if (params.has('email') && params.has('impersonation_id')) {
                this.model.email=params.get('email');
                this.model.impersonation_id = params.get('impersonation_id');
                this.submit();
            }
            if(params.has('external_token'))
            {
                this.model.external_token = params.get('external_token');
                this.submit();
            }
        });

    }
}
